module.exports = "/_next/static/images/baseballWhiteIcon@3x-b5f3b659d46324e3cb27eefa19f7bd80.png";